import { useLocalStorage } from '@gasbuddy/react-hooks';
import { useCallback, useMemo } from 'react';

export default function useParsedLocalStorage(name, defaultValue) {
  const [value, setValue] = useLocalStorage(name, defaultValue);
  const transformedValue = useMemo(() => JSON.parse(value), [value]);
  const updateValue = useCallback(newValue => setValue(JSON.stringify(newValue)), [setValue]);
  return [transformedValue, updateValue];
}
